import { Observable } from 'rxjs';

import { Response } from '@shure/shared/angular/data-access/system-api/models';

import { CertificateInfo, Sh8021xConfig, Sh8021xSettingsDevice } from './models';

export interface CertValidationResponse {
	certificateInfo?: CertificateInfo;
	error?: string;
}

export abstract class Settings8021xApiService {
	public abstract getDevice$(deviceId: string): Observable<Sh8021xSettingsDevice>;
	public abstract set8021xConfig(deviceId: string, config: Sh8021xConfig): Observable<Response<void, string>>;
	public abstract validateCertificate(certificate: string): Observable<Response<CertValidationResponse, string>>;
	public abstract set8021xEnabled(
		deviceId: string,
		enable: boolean,
		rebootNow: boolean
	): Observable<Response<void, string>>;
	public abstract reset8021xConfig(deviceId: string, rebootNow: boolean): Observable<Response<void, string>>;
	public abstract rebootDevice(deviceId: string): Observable<Response<void, string>>;
}
